import React from 'react';
import {
    Paper,
    Table,
    TableBody
} from 'material-ui';
import MenusTableHeader from './MenusTableHeader';
import MenusTableItem from './MenusTableItem';

class MenusTable extends React.Component {

    render() {

        const {
            classes,
            menus,
            sites,
            handleClickOpen
        } = this.props;

        return (
            <Paper className={classes.rootMenusTable}>
                <Table className={classes.table}>
                    <MenusTableHeader
                        classes={classes}
                    />
                    <TableBody>
                        {menus.map((menu, index) =>
                            <MenusTableItem
                                key={menu.id}
                                menu={menu}
                                sites={sites}
                                handleClickOpen={handleClickOpen}
                                classes={classes}
                            />
                        )}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

export default MenusTable;



// WEBPACK FOOTER //
// ./src/containers/menus/MenusTable.jsx